import { render, staticRenderFns } from "./indexOverseasChineseMerchant.vue?vue&type=template&id=4a80d3fb&scoped=true&"
import script from "./indexOverseasChineseMerchant.vue?vue&type=script&lang=js&"
export * from "./indexOverseasChineseMerchant.vue?vue&type=script&lang=js&"
import style0 from "./indexOverseasChineseMerchant.vue?vue&type=style&index=0&id=4a80d3fb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80d3fb",
  null
  
)

export default component.exports